<template>
  <div :class="['comment-box', isDark ? 'dark-theme' : '']">
    <div class="scoped-css">
      <div v-if="showCommentList" style="margin-bottom: 20px;">
        <div class="title">评论（{{ detail.comment_count }}）</div>
        <DetailEmojiBar :detail="detail" :isDark="isDark" @emojiCheck="onEmojiCheck" />
      </div>
      <DetailComment
        :isPage="true"
        :isDark="isDark"
        :detail="detail"
        :list="commentList"
        :pagination="commentListParams"
        :showCommentList="showCommentList"
        @refresh="refresh"
        @getCommentList="getCommentList"
      />
      <!-- 交叉观察器：当此元素出现在视口中，则加载下一页评论 -->
      <div ref="trigger" class="trigger"></div>
    </div>
  </div>
</template>
<script>
// components
import DetailEmojiBar from "@/views/wiki/detail/components/detailEmojiBar.vue";
import DetailComment from "@/views/wiki/detail/components/detailComment.vue";

// api
import { apiCommentList } from "@/api/commentApi";

export default {
  name: "CommentDetails",
  components: { DetailComment, DetailEmojiBar },
  props: {
    isDark: { type: Boolean, default: false },
    /** 是否显示评论列表 */
    showCommentList: { type: Boolean, default: true },
    /** 评论数据 */
    commentList: { type: Array, default: () => [] },
    /** 评论分页参数 */
    commentListParams: { type: Object, required: true },
    rootQueryselector: { type: String, default: null },
    detail: {
      type: Object,
      default: () => {
        return {
          content_json: "",
          entry_data_bind: []
        };
      }
    }
  },
  data() {
    return {
      loadCommentStatus: ""
    };
  },
  mounted() {
    this.createIntersectionObserver();
  },
  methods: {
    async createIntersectionObserver() {
      await new Promise(resolve => setTimeout(resolve, 300));
      const trigger = this.$refs.trigger;
      if (!trigger || !this.showCommentList) return;
      let root = null;
      if (this.rootQueryselector) {
        root = document.querySelector(this.rootQueryselector);
      }
      const options = {
        root,
        rootMargin: "5px",
        threshold: 0
      };
      const callback = entries => {
        entries.forEach(entry => {
          if (entry.target === trigger && entry.isIntersecting) {
            this.getCommentList();
          }
          if (entry.target === this.$el.querySelector("div.detail-comment")) {
            let value = 0;

            if (!entry.isIntersecting) {
              // 元素已经不在视口中，判断是从上方还是下方离开

              const rect = entry.boundingClientRect;

              if (rect.bottom < 0) {
                value = -1;
                // 元素的整个底部已经在视口顶部之上，说明是从上往下滑动时离开的
              } else if (rect.top > window.innerHeight) {
                value = 1;
                // 元素的整个顶部已经在视口底部之下，说明是从下往上滑动时离开的
              } else {
                // 其他情况，可能部分不可见，或者根不是视口，需要更复杂的判断
                value = 0;
              }
            } else {
              // 元素进入或正在视口中
              value = 0;
            }
            this.$emit("commentBoxIntersecting", value);
          }
        });
      };
      const observer = new IntersectionObserver(callback, options);
      observer.observe(trigger);
      observer.observe(this.$el.querySelector("div.detail-comment"));
      this.observer = observer;
    },
    // 刷新详情
    refresh(detail, user) {
      // 将服务端数据置空，防止动态切换默认渲染此数据
      this.$store.commit("set_ssr_component_data", []);
      if (detail) {
        this.$set(this, "detail", detail);
      }
      if (user) {
        this.$set(this, "user", user);
      }
    },
    // 获取评论
    async getCommentList(type) {
      const { id = "" } = this.$route.params;
      if (id.includes("_")) return;
      if (type === "refresh") {
        this.$emit("updateCommentList", []);
        this.$emit("updateCommentListParams", {
          limit: 10,
          page_no: 0,
          page_total: 1,
          total: 0
        });
      }
      await this.$nextTick();
      const pagination = this.commentListParams;
      if (pagination.page_no >= pagination.page_total) {
        this.loadCommentStatus = "end";
        return;
      }
      const params = {
        ...pagination,
        content_id: Number(id)
      };
      ++params.page_no;
      this.loadCommentStatus = "loading";
      await apiCommentList(params)
        .then(res => {
          if (res.code === 0) {
            const list = this.commentList.concat(res.data);
            this.detail.comment_count = res.meta.pagination.total;
            this.$emit("updateCommentList", list);
            this.$emit("updateCommentListParams", res.meta.pagination);
          }
        })
        .finally(_ => {
          this.loadCommentStatus = "";
        });
    },
    onEmojiCheck() {
      if (this.detail.is_like === 0) {
        this.detail.like_count++;
      }
      this.detail.is_like = 1;
    }
  }
};
</script>

<style lang="less" scoped>
.comment-box /deep/ .scoped-css {
  width: 100%;
  display: flex;
  flex-direction: column;
  title {
    color: #000000;
  }
  .wiki-comment-list {
    background: transparent;
  }
}
.comment-box.dark-theme /deep/ .scoped-css {
  .title {
    color: #fff;
  }

  .detail-comment {
    background: #121212;

    .detail-comment-send {
      background: transparent;
      .comment-input {
        background: transparent;
        color: #fff;
        &:empty:before {
          content: attr(placeholder);
          color: #8a8d91;
          font-size: 13px;
        }
      }
      .tool-bar .cancel-btn {
        color: #fff;
      }
    }
  }

  .comment-to-comment {
    background: rgba(148, 149, 150, 0.06);
  }
  .content,
  .replay-content {
    color: #fff !important;
  }

  .send-btn {
    background: rgba(56, 108, 158, 0.63);
  }
  .cancel-btn {
    background: rgba(111, 114, 116, 0.5);
  }

  .answer {
    color: #3f77a7 !important;
  }

  .emoji {
    background: rgba(148, 149, 150, 0.1);
  }
}
</style>
